<template>
    <div class="page p-6">
        <h1 class=" text-4xl mb-4">{{ entry.title }}</h1>
        <hr class="mb-4">
        <div v-html="entry.body"></div>
    </div>
</template>

<script>


export default {
  components: {
  },
  data: function () {
    return {
      slug: this.$route.params.slug,
      entry: {}
    }
  },
  mounted () {
    this.$http.get('/api/page/' + this.slug)
      .then(response => (this.entry = response.data));
  }
}
</script>

<style>
    .page p + p {
        @apply mt-2;
    }
    .page h1 {
        @apply text-4xl mb-4;
    }
    .page h2 {
        @apply text-2xl mb-4 mt-6;
    }
    .page h3 {
        @apply text-lg mb-4 mt-4 font-bold;
    }
    .page a {
        @apply underline;
    }
    .page strong {
        @apply font-bold
    }
    .page em {
        @apply italic
    }
</style>